import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import QuickActions from "../components/QuickActions";
import StatCard from "../components/StatCard";
import ActivityFeed from "../components/ActivityFeed";
import "../styles/Dashboard.css";

function FreelancerDashboard() {
  const [stats, setStats] = useState({
    totalProjects: 0,
    activeProjects: 0,
    completedProjects: 0,
    totalEarnings: 0,
  });

  useEffect(() => {
    // Fetch freelancer-specific stats
    // For now, dummy data
    setStats({
      totalProjects: 10,
      activeProjects: 3,
      completedProjects: 7,
      totalEarnings: 25000,
    });
  }, []);

  return (
    <div className="dashboard-page">
      <Sidebar />
      <div className="dashboard-content">
        <div className="dashboard-header">
          <h1>Welcome back, Freelancer!</h1>
          <p>Track your projects and earnings.</p>
        </div>

        <div className="stats-grid">
          <StatCard title="Total Projects" value={stats.totalProjects} />
          <StatCard title="Active Projects" value={stats.activeProjects} />
          <StatCard title="Completed Projects" value={stats.completedProjects} />
          <StatCard title="Total Earnings" value={`$${stats.totalEarnings.toLocaleString()}`} />
        </div>

        <QuickActions />

        <div className="dashboard-sections">
          <ActivityFeed />
        </div>
      </div>
    </div>
  );
}

export default FreelancerDashboard;
